import { scrollToTop } from "@/lib/scrollContainer.ts"
import {
  createRouter,
  createWebHistory,
  Router,
  RouteRecordRaw,
} from "vue-router"

import { authGuard } from "./middleware/authGuard.ts"
import { autoLoginGuard } from "./middleware/autoLoginGuard.ts"
import { metaTitleGuard } from "./middleware/metaTitleGuard.ts"
import { nativeHotjarInitEventHook } from "./middleware/nativeHotjarInitEventHook.ts"
import { redirectGuard } from "./middleware/redirectGuard.ts"

let router: Router | null = null

const routerFactory = (routes: readonly RouteRecordRaw[]): Router => {
  if (router !== null) {
    return router
  }

  router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    // Native scrolls an inner container rather than the document (see NativeLayout), so a
    // position returned here would be applied to a window that never scrolls. Do it ourselves
    // and tell vue-router we have handled it.
    scrollBehavior() {
      scrollToTop()
      return false
    },
  })

  // Navigation Guards:
  router.beforeEach(autoLoginGuard)
  router.beforeEach(redirectGuard)
  router.beforeEach(authGuard)
  router.beforeEach(metaTitleGuard)

  // Navigation After Hooks:
  router.afterEach(nativeHotjarInitEventHook)

  return router
}

export default routerFactory
